/**
 * UI hide flag for Sign-off / Control Center feature.
 *
 * Set to `true` to hide all Sign-off UI (tab + inline indicators) for all users
 * without touching the feature flag system or backend.
 *
 * Data layer (queries, hooks, DB) is UNTOUCHED — feature can be re-enabled by
 * flipping this to `false` and redeploying.
 *
 * To toggle: change value and redeploy. No DB migration needed.
 */
export const HIDE_CONTROL_UI = true;
